import { Pipe, PipeTransform } from '@angular/core';
import { UserService } from '../../core/services';
import { ServiceCreditTypesEnum } from '../../core/models/user.model';
import { Observable } from 'rxjs';

@Pipe({
  name: 'hasServiceCredits',
  standalone: true,
})
export class HasServiceCreditPipe implements PipeTransform {
  constructor(private readonly userService: UserService) {
  }

  transform(types: ServiceCreditTypesEnum | ServiceCreditTypesEnum[]): Observable<boolean> {
    return this.userService.hasServiceCredit(types)
  }
}
